// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

export default class ViewControl extends React.Component {
    render = () => {
        return (<img
            className="title-control hover-grow"
            style={this.props.style ? this.props.style : {}}
            src={"https://static.stax.ai/images/icons/" + this.props.view + ".png"}
            alt={this.props.view === 'list' ? 'Grid' : 'List'}
            title={this.props.view === 'list' ? "Toggle grid view" : "Toggle list view"}
            onClick={() => this.props.setView(this.props.view === 'list' ? 'grid' : 'list')}
        />);
    }
};